import { Box, Button, Modal, Stack, Typography } from "@mui/material";

type props = {
  open: boolean;
  day: number;
  name: string;
  month: number;
  year: number;
  setOpen: Function;
  leave: string;
};

const LeaveDataModal: React.FC<props> = ({
  open,
  day,
  name,
  month,
  year,
  setOpen,
  leave,
}) => {
  const EditCustomerModalStyle = {
    position: "absolute" as "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "22px",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal open={open}>
      <Box sx={EditCustomerModalStyle}>
        <Stack alignItems={"center"} spacing={2}>
          <Stack>
            <Typography variant="h5" fontWeight={500} textAlign="center">
              {name} on {leave}
            </Typography>
            <Typography variant="h5" fontWeight={500} textAlign="center">
              ({day}/{month}/{year})
            </Typography>
          </Stack>

          <Button variant="contained" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LeaveDataModal;
